import React, { useState } from "react";
import { Form, FormGroup } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { userSignUp } from "../util/api";

const Register = () => {
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [userName, setUserName] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    const obj = {
      username: userName,
      email: email,
      password: pass,
    };
    userSignUp(obj).then((resp) => {
      console.log("resp", resp);
      if (resp.status === "Success") {
        localStorage.setItem("token", resp.token);
        navigate("/");
        window.location.reload();
        setIsLoading(false);
      }
    });
  };
  return (
    <>
      <Form onSubmit={handleSubmit}>
        <FormGroup className="login__form d-flex align-items-center gap-4 mb-4">
          <span>
            <i class="ri-user-line"></i>
          </span>
          <input
            type="text"
            placeholder="Username"
            required
            onChange={(e) => setUserName(e.target.value)}
          />
        </FormGroup>
        <FormGroup className="login__form d-flex align-items-center gap-4 mb-4">
          <span>
            <i class="ri-mail-line"></i>
          </span>
          <input
            type="email"
            placeholder="Email"
            required
            onChange={(e) => setEmail(e.target.value)}
          />
        </FormGroup>

        <FormGroup className="login__form d-flex align-items-center gap-4 mb-4">
          <span>
            <i class="ri-lock-2-line"></i>
          </span>
          <input
            type="password"
            placeholder="Password"
            required
            onChange={(e) => setPass(e.target.value)}
          />
        </FormGroup>
        <button className="login__btn " type="submit">
          {isLoading ? "Loading..." : "Register Now"}
        </button>
      </Form>
      <h6 className="fs-6 text-center mt-4">
        <Link to="/signin">Already Have an Account?</Link>
      </h6>
    </>
  );
};

export default Register;
